import * as taskName from './task-name'
import * as processUI from '../../process-ui'
import * as processAction from '../../process-action'
import { createValidationMessage } from '../../../../validation/create-validation-message'
import { selectProcessContext } from '../../../state/instance-detail/selector'

export default {
    taskName: taskName.SHIP_ALIGNER_EXTERNAL,
    taskOverviewProps: {},
    widgetList: [
        {
            component: processUI.OVERVIEW,
        },
        {
            component: processUI.SUPPLIER_TRACKING_NUMBER_WIDGET,
        },

    ],
    actionList: [
        {
            action: processAction.PROCESS_INSTANCE,
            taskPath: ['processInstance'],
        },
        {
            action: processAction.TREATMENT_PLAN,
            taskPath: ['objectDetail', 'customer', 'treatmentPlanList', 0],
        },
        {
            action: processAction.SALES_ORDER,
            taskPath: ['objectDetail'],
        },
        {
            action: processAction.CUSTOMER,
            taskPath: ['objectDetail', 'customer'],
        },
    ],
    taskValidatorSelector: [
        selectProcessContext,
    ],
    taskValidator: (task, processInstance, taskName, eventName, context) => {
        const messageList = []

        const trackingNumber = context.supplierTrackingNumber
        if (!trackingNumber) {
            messageList.push(createValidationMessage('Please add the tracking number before proceeding.', 'checkDeliveryTracking.checkDeliveryTracking'))
        }

        return messageList
    },
}



// WEBPACK FOOTER //
// ./src/modules/process/ui-definition/sales-order/treatment/ship-aligner-external.js